import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LastLocationProvider } from 'react-router-last-location';
import { Redirect } from 'react-router';

import fetchDux from '../state/fetch-dux';

import AccountRoutes from './routes/AccountRoutes';
import LoginRoute from './routes/LoginRoute';
import SignUpRoute from './routes/SignUpRoute';
import ProductPage from './routes/shop/ProductPage';
import ShopGrid from './routes/shop/ShopGrid';
import CartPage from './routes/shop/CartPage';
import CheckoutShipping from './routes/shop/CheckoutShipping';
import CheckoutBilling from './routes/shop/CheckoutBilling';
import CheckoutReview from './routes/shop/CheckoutReview';
import CheckoutConfirmation from './routes/shop/CheckoutConfirmation';
import ForgotPasswordRoute from './routes/ForgotPasswordRoute';
import ResetPasswordRoute from './routes/ResetPasswordRoute';
import VerifyAccountRoute from './routes/VerifyAccountRoute';
import ShopLoginRoute from './routes/ShopLoginRoute';
import ProductNotFound from './routes/shop/ProductNotFound';
import NotFound from './routes/NotFound';
import Maintenance from './routes/Maintenance';
import { actionCreators } from '../state/wordpress-dux';

const SHOW_MAINTENANCE = process.env.REACT_APP_MAINTENANCE === 'true';

const MaintenanceCheck = ({ children }) => {
  if (SHOW_MAINTENANCE) return <Maintenance />;
  return children;
};

class App extends Component {
  componentDidMount() {
    this.props.getCart();
    this.props.validateLogin();
    this.props.getWordpress();
  }
  render() {
    return (
      <Router>
        <LastLocationProvider>
          <MaintenanceCheck>
            <Switch>
              <Route exact path="/not-found" component={NotFound} />
              <Route
                exact
                path="/shop/product-not-found"
                component={ProductNotFound}
              />
              <Route exact path="/shop/p/:slug" component={ProductPage} />
              <Route path="/shop/cart" component={CartPage} />
              <Route path="/shop/login" component={ShopLoginRoute} />
              {/* <Route
                path="/shop/checkout/shipping"
                component={CheckoutShipping}
              />
              <Route path="/shop/checkout/billing" component={CheckoutBilling} />
              <Route path="/shop/checkout/review" component={CheckoutReview} />
              <Route
                path="/shop/checkout/confirmation"
                component={CheckoutConfirmation}
              /> */}
              <Route exact path="/shop/:filter?" component={ShopGrid} />
              <Route exact path="/account/login" component={LoginRoute} />
              <Route exact path="/account/sign-up" component={SignUpRoute} />
              <Route
                exact
                path="/account/forgot-password"
                component={ForgotPasswordRoute}
              />
              <Route
                exact
                path="/account/reset-password"
                component={ResetPasswordRoute}
              />
              <Route
                exact
                path="/account/verify"
                component={VerifyAccountRoute}
              />
              <Route path="/account" component={AccountRoutes} />
              <Redirect to="/shop" />
            </Switch>
          </MaintenanceCheck>
        </LastLocationProvider>
      </Router>
    );
  }
}

const mapState = state => ({});

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      // validateLogin: fetchDux.validateLogin.createAction
      ...actionCreators,
      getCart: fetchDux.getCart.createAction,
      validateLogin: fetchDux.validateLogin.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(App);
